import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 15px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
`;

export const HeaderBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 30px;
`;

export const Logo = styled.img`
  max-width: 200px;
  margin-right: 30px;

  @media (${mobileXXLargeMax}) {
    max-width: 60px;
    margin-right: 10px;
  }
`;

export const SubtitleBlock = styled.div`
  text-align: center;
  max-width: 1048px;
  margin-bottom: 25px;
`;

export const Content = styled.div<{ maxWidth?: number }>`
  position: relative;
  max-width: ${(props) => props.maxWidth || 1024}px;
  width: 100%;
  padding: 30px;
  border: solid 1px #d8d8d8;
  background-color: rgba(255, 255, 255, 0.8);

  @media (${mobileXXLargeMax}) {
    padding: 60px 15px 30px;
  }
`;

export const LinksContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1024px;
  justify-content: space-evenly;

  @media (${mobileXXLargeMax}) {
    flex-direction: column;
  }
`;

export const Icon = styled.div`
  border: solid 1px ${({ theme }) => theme.lightGrey};
  border-radius: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const LinkItem = styled.div`
  display: flex;
  align-items: center;

  &:hover {
    p,
    svg {
      color: ${({ theme }) => theme.backgroundLight};
    }
  }

  @media (${mobileXXLargeMax}) {
    margin-bottom: 15px;
  }
`;
